import { WHY_US } from "@/lib/site-data";
import FadeIn from "@/components/FadeIn";

export default function WhyUs() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 sm:py-32 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-5">
          <FadeIn>
            <div className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#2C7A7B]">
              <span className="h-px w-8 bg-[#2C7A7B]" />
              Why Choose Us
            </div>
          </FadeIn>
          <FadeIn delay={100}>
            <h2 className="mt-5 font-display text-[#0F3D3E] text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Less admin.
              <br />
              <span className="italic">More wonder.</span>
            </h2>
          </FadeIn>
          <FadeIn delay={200}>
            <p className="mt-7 text-[#0A0A0A]/70 leading-relaxed max-w-md">
              A travel partner you can actually call. Five reasons our
              travellers keep coming back, and sending their friends.
            </p>
          </FadeIn>
        </div>

        <div className="lg:col-span-7">
          <div className="grid gap-4">
            {WHY_US.map((w, i) => (
              <FadeIn
                key={w.title}
                delay={i * 80}
                data-testid={`why-card-${i}`}
                className="group flex items-start gap-5 rounded-2xl border border-[#0F3D3E]/10 bg-white p-6 sm:p-7 hover:border-[#2C7A7B]/50 hover:-translate-y-0.5 transition-all"
              >
                <div className="font-display text-4xl text-[#2C7A7B]/30 group-hover:text-[#2C7A7B] transition-colors w-12 shrink-0">
                  0{i + 1}
                </div>
                <div>
                  <h3 className="font-display text-2xl text-[#0F3D3E] leading-snug">
                    {w.title}
                  </h3>
                  <p className="mt-2 text-[#0A0A0A]/70 text-sm leading-relaxed">
                    {w.body}
                  </p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
